module.exports = __webpack_public_path__ + "static/media/food_3.edb43abf.jpeg";